const data = {
  fielddata: {},
  Errors: {},
  selectedRow: [],
  selectedRows: [],
  selectedRowForModalTable: [],
  selectedRowsForModalTable: [],
  MultiSelectedRows: [],
  typeOfForm: [],
  refresh: false,
  masterData: {},
  singleCompanyData: {},
  singleBranchData: {},
  commonState: [],
  submitButtonForm: false,
};
export function FormActionReducer(state = data, { type, payload }) {
  switch (type) {
    case "typeofForm": {
      return {
        ...state,
        typeOfForm: payload,
      };
    }
    case "addload": {
      return {
        ...state,
        fielddata: {
          ...state.fielddata,
          [payload.key]: payload.data,
        },
      };
    }
    case "Form_Errors": {
      return {
        ...state,
        Errors: {
          ...state.Errors,
          [payload.key]: payload.data,
        },
      };
    }
    case "Clear_Errors": {
      return {
        ...state,
        Errors: {},
      };
    }
    case "Add_FormFieldData": {
      return {
        ...state,
        fielddata: {
          ...state.fielddata,
          [payload.key]: { ...state.fielddata[payload.key], ...payload.data },
        },
      };
    }
    case "SetFormFielddata": {
      return {
        ...state,
        fielddata: payload,
      };
    }
    case "selectedRow": {
      let array = [];
      if (payload[0]) {
        array.push(payload[0].original);
      }
      return { ...state, selectedRow: array };
    }
    case "selectedRows": {
      const array = [];
      for (var i = 0; i < payload.length; i++) {
        array.push(payload[i].original);
      }
      return { ...state, selectedRows: array };
    }
    case "selectedRowForModalTable": {
      let array = [];
      if (payload[0]) {
        array.push(payload[0].original);
      }
      return { ...state, selectedRowForModalTable: array };
    }
    case "selectedRowsForModalTable": {
      const array = [];
      for (var a = 0; a < payload.length; a++) {
        array.push(payload[a].original);
      }
      return { ...state, selectedRowsForModalTable: array };
    }

    case "MultiSelectedRows": {
      const array = [];
      for (var l = 0; l < payload.branchIds.length; l++) {
        array.push(payload.branchIds[l].original);
      }
      return {
        ...state,
        MultiSelectedRows: {
          ...state.MultiSelectedRows,
          [payload.compId]: [...array],
        },
      };
    }

    case "SearchMasterData": {
      return { ...state, masterData: { ...state.masterData, ...payload } };
    }

    case "SingleCompanyData": {
      return { ...state, singleCompanyData: { ...payload } };
    }

    case "SingleBranchData": {
      return { ...state, singleBranchData: { ...payload } };
    }
    case "coomonStateForTable": {
      return { ...state, commonState: { ...state.commonState, ...payload } };
    }

    case "ClearData": {
      if (payload?.data) {
        state = {
          ...state,
          fielddata: {},
          selectedRow: state.selectedRow,
          selectedRows: state.selectedRows,
          masterData: {},
          Errors: {},
          //  refresh: false,
        };
        return state;
      } else {
        let f = state.fielddata;
        state = {
          ...state,
          ...payload,
          fielddata: { ...f, ...payload?.fielddata },
        };
        return state;
      }
    }
    case "Submit_button_Form": {
      return {
        ...state,
        submitButtonForm: true,
      };
    }
    case "Reset_Submit_button_Form": {
      return {
        ...state,
        submitButtonForm: false,
      };
    }

    case "Refetch": {
      state = {
        ...state,
        refresh: payload,
      };
      return state;
    }
    default: {
      return state;
    }
  }
}
